{
  "name": "igrid",
  "version": "1.5.0",
  "scripts": {
    "ng": "ng",
    "start": "npm run start:serviceportal:remote",
    "start:serviceportal": "ng serve serviceportal",
    "start:serviceportal:remote": "ng serve serviceportal --configuration=remote",
    "build:serviceportal": "ng build serviceportal --configuration production --base-href /service/ --deploy-url /service/",
    "start:serviceportal:test": "ng serve serviceportal --configuration=test",
    "build:serviceportal:test": "ng build serviceportal --configuration=test",
    "start:shared": "ng build shared --watch",
    "build:shared": "ng build shared",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.21",
    "@angular/cdk": "^21.2.0",
    "@angular/common": "^21.2.21",
    "@angular/compiler": "^21.2.21",
    "@angular/core": "^21.2.21",
    "@angular/forms": "^21.2.21",
    "@angular/localize": "^21.2.21",
    "@angular/platform-browser": "^21.2.21",
    "@angular/platform-browser-dynamic": "^21.2.21",
    "@angular/router": "^21.2.21",
    "@azure/msal-angular": "^4.1.1",
    "@azure/msal-browser": "^4.30.0",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ng-select/ng-select": "^21.5.2",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@popperjs/core": "^2.11.8",
    "@tinkoff/ng-polymorpheus": "^4.3.0",
    "@types/lodash": "^4.17.17",
    "ang-jsoneditor": "^2.0.0",
    "jsoneditor": "^9.10.5",
    "lodash": "^4.17.21",
    "merge": "^2.1.1",
    "moment": "^2.30.1",
    "ngx-dropzone": "^3.1.0",
    "primeng": "^21.1.1",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.21",
    "@angular-eslint/builder": "^21.2.0",
    "@angular-eslint/eslint-plugin": "^21.2.0",
    "@angular-eslint/eslint-plugin-template": "^21.2.0",
    "@angular-eslint/template-parser": "^21.2.0",
    "@angular/cli": "^21.2.21",
    "@angular/compiler-cli": "^21.2.21",
    "@types/jasmine": "~3.10.18",
    "@types/node": "^24.11.0",
    "bootstrap": "^5.3.8",
    "eslint": "^9.26.0",
    "eslint-config-prettier": "^9.1.0",
    "jasmine-core": "~4.6.1",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~4.0.2",
    "karma-jasmine-html-reporter": "^1.7.0",
    "knip": "^5.85.0",
    "marked": "^17.0.3",
    "ng-packagr": "^21.2.0",
    "primeicons": "^7.0.0",
    "typescript": "^5.9.3"
  },
  "overrides": {
    "serialize-javascript": "^7.0.5",
    "browserslist": "4.28.7",
    "baseline-browser-mapping": "2.11.0",
    "uuid": "11.1.1"
  }
}